import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';

export const useCreateContractPDF = () => {
  const { responseStreamHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useCreateContractPDF');

  return useMutation<Blob, DefaultError, string>({
    mutationFn: async body => {
      loading(
        i18next.t('service-code.create.loading', {
          what: 'PDF',
        })
      );
      const formData = new FormData();

      formData.append('contractId', body);

      const response = await apiClient({
        method: 'POST',
        url: `Contract/PDF`,
        body: formData,
        withContentType: false,
      });

      return responseStreamHandler(response);
    },
    onSuccess: data => {
      success(
        i18next.t('service-message.create.success', {
          what: 'PDF',
        })
      );
    },
    onError: dismiss,
  });
};
